import { css } from '@emotion/core';

const styles = {
  table: css({
    width: 1380,
    position: 'relative',
  }),
  recordNo: css({
    width: 80,
    textAlign: 'center',
    position: 'sticky',
    left: 0,
    top: 0,
    zIndex: 999,
  }),
  store: css({
    width: 280,
    textAlign: 'center',
    position: 'sticky',
    left: 82,
    top: 0,
    zIndex: 999,
  }),
  cardNo: css({
    width: 80,
    textAlign: 'center',
    position: 'sticky',
    left: 364,
    top: 0,
    zIndex: 999,
  }),
  notLinked: css({
    width: 80,
    textAlign: 'center',
    position: 'sticky',
    top: 0,
    zIndex: 9,
  }),
  depositAmount: css({
    width: 100,
    textAlign: 'center',
    position: 'sticky',
    top: 0,
    zIndex: 9,
  }),
  withdrawalAmount: css({
    width: 100,
    textAlign: 'center',
    position: 'sticky',
    top: 0,
    zIndex: 9,
  }),
  depositAmountNo: css({
    width: 100,
    textAlign: 'right',
  }),
  withdrawalAmountNo: css({
    width: 100,
    textAlign: 'right',
  }),
  balance: css({
    width: 100,
    textAlign: 'center',
  }),
  businessDayStart: css({
    width: 160,
    textAlign: 'center',
    position: 'sticky',
    top: 0,
    zIndex: 9,
  }),
  businessDayEnd: css({
    width: 160,
    textAlign: 'center',
    position: 'sticky',
    top: 0,
    zIndex: 9,
  }),
  specialBusinessDay: css({
    width: 80,
    textAlign: 'center',
  }),
  remarks: css({
    width: 350,
    textAlign: 'center',
    position: 'sticky',
    top: 0,
    zIndex: 9,
  }),
  reasonForChange: css({
    width: 350,
    textAlign: 'center',
    position: 'sticky',
    top: 0,
    zIndex: 9,
  }),
  reasonForChangeNoSticky: css({
    width: 350,
    textAlign: 'center',
  }),
  remarksBodyTextLeft: css({
    width: 350,
    textAlign: 'left',
  }),
  // For sticky cells
  recordNoStickyBody: css({
    width: 80,
    textAlign: 'center',
    position: 'sticky',
    left: 0,
    backgroundColor: '#FFF',
  }),
  storeStickyBody: css({
    width: 280,
    position: 'sticky',
    left: 82,
    backgroundColor: '#FFF',
    overflow: 'unset',
  }),
  cardNoStickyBody: css({
    width: 80,
    textAlign: 'center',
    position: 'sticky',
    left: 364,
    backgroundColor: '#FFF',
  }),
  dateChangeStatus: css({
    width: 55,
    textAlign: 'center',
    position: 'sticky',
    top: 0,
    zIndex: 9,
    padding: 0,
  }),
  notLinkedStickyBody: css({
    textAlign: 'center',
    '& > div': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  }),
};

export default styles;
